var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarshipHyperion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d6d6d6;\n      }\n\n      .cls-2 {\n        fill: #e20a0a;\n      }\n\n      .cls-3 {\n        fill: #e2e2e2;\n      }\n\n      .cls-4 {\n        fill: #454545;\n      }\n\n      .cls-5 {\n        fill: #1e1e1e;\n      }\n\n      .cls-6 {\n        opacity: .5;\n      }\n\n      .cls-6, .cls-7 {\n        fill: #c40e0e;\n      }\n\n      .cls-8 {\n        fill: #565656;\n      }\n\n      .cls-9 {\n        fill: #878787;\n      }\n\n      .cls-10 {\n        fill: #0c0c0c;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "619.82 392.75 370.82 370.57 453.82 365.57 619.82 392.75"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "262.82 394.57 193.82 394.57 171.82 372.57 619.82 392.75 262.82 394.57"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.87 392.18 149.58 385.39 149.58 353.55 175.87 346.76 175.87 392.18"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "440.82 410.66 265.86 424.86 265.86 386.98 440.82 401.07 440.82 410.66"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "299.82 433.57 167.82 433.57 172.98 372.94 324.82 376.57 299.82 433.57"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "172.98 372.94 168.82 354.57 619.82 392.75 172.98 372.94"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "386.82 373.57 168.82 354.57 191.82 309.57 468.82 367.57 386.82 373.57"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "380.82 363.57 344.82 341.57 440.82 361.57 380.82 363.57"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "291.82 364.57 168.82 354.57 140.82 261.57 233.82 298.57 291.82 364.57"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "209.33 358.32 168.33 354.32 140.33 261.32 160.33 269.32 209.33 358.32"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "163.82 427.57 152.33 445.32 313.33 442.32 365.33 427.32 163.82 427.57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarshipHyperion);
export default __webpack_public_path__ + "static/media/starship-hyperion.a561f98f47530fabbd002a9c487eac7b.svg";
export { ForwardRef as ReactComponent };